import React, { useContext, useEffect, useState } from "react";
import Header from "./Header";
import maincss from './MainCSS.module.css';
import { urlContext } from "./UrlContext";

const Dashboard = () => {

    const [totalClients, setTotalClients] = useState();
    const [newClients, setNewClients] = useState();

    const { baseurl } = useContext(urlContext);

    const getTotalClients = () => {
        const url = baseurl + "/getTotalClients.php";

        fetch(url)
        .then(response => response.json())
        .then(responseData => {
            const data = responseData.map(function (row) {
                return (
                    <div key={row.sn} className={maincss.boxCont}>
                        <div className={maincss.box}>
                            <p>{row.totalClients}</p>
                            <h2>Total<br />Clients</h2>
                        </div>
                        <div className={maincss.box}>
                            <p>{row.MikrotikClients}</p>
                            <h2>Mikrotik 71<br />Clients</h2>
                        </div>
                        <div className={maincss.box}>
                            <p>{row.FiberlinkClients}</p>
                            <h2>Fiberlink<br />Clients</h2>
                        </div>
                    </div>
                )
            })
            setTotalClients(data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const getNewClients = () => {
        const url = baseurl + "/getNewClients.php";

        fetch(url)
        .then(response => response.json())
        .then(responseData => {
            const data = responseData.map(function (row) {
                return (
                    <div key={row.sn} className={maincss.boxCont}>
                        <div className={maincss.box}>
                            <p>{row.newclients}</p>
                            <h2>Today's New Clients</h2>
                        </div>
                    </div>
                )
            })
            setNewClients(data);
        }).catch((err) => {
            console.log(err);
        })
    }

    useEffect(() => {
        getTotalClients();
        getNewClients();
    })

    return (
        <div className={maincss.dashboardCont}>
            <Header />

            <div>
                <h1>Dashboard</h1>

                <div className={maincss.boxCont}>
                    {totalClients}
                    
                    {newClients}
                </div>
            </div>
        </div>
    )
}

export default Dashboard;